"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBlockExplorerTransaction = void 0;
exports.formatBlockExplorerTransaction = (blockExplorer) => (transactionId) => {
    switch (blockExplorer) {
        case `bloks`:
            return `https://bloks.io/transaction/${transactionId}`;
        case `eosq`:
            return `https://eosq.app/tx/${transactionId}`;
        default:
            throw new Error(`Unsupported block explorer: ${blockExplorer}`);
    }
};
